import styled from 'styled-components';
import { blueIcon, darkGreen, greyLight, tableLightGray, white } from '../../../../styles/Variables';

export const SecondHandMachinesAccordionTableContainer = styled.div`
    overflow-x: auto;
    margin-top: 5px;
`;

export const SecondHandMachinesAccordionTableBox = styled.table`
    min-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-style: hidden;
`;

export const SecondHandMachinesAccordionTableRow = styled.tr`
    background-color: ${greyLight};

    &:nth-child(odd) {
        background-color: ${white};
    }
`;

interface SecondHandMachinesAccordionBasedItemType {
    readonly isPrice?: boolean;
    readonly sortType?: string;
}

export const SecondHandMachinesAccordionBasedItem = styled.td<SecondHandMachinesAccordionBasedItemType>`
    font-size: 15px;
    border: 1px solid ${white};
    padding: 15px 20px;
    font-family: Arial, Helvetica, sans-serif;
    ${(props) => props.isPrice && `text-align: right;`}
`;

export const SecondHandMachinesAccordionTableItem = styled(SecondHandMachinesAccordionBasedItem)`
    a {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        color: ${blueIcon};

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const SecondHandMachinesAccordionTableHeader = styled.th<SecondHandMachinesAccordionBasedItemType>`
    font-size: 15px;
    border: 1px solid ${white};
    font-family: Arial, Helvetica, sans-serif;
    ${(props) => props.isPrice && `text-align: right;`}
    background-color: ${tableLightGray};
    font-weight: 700;

    * {
        margin: 0;
        padding: 0;
    }
`;

export const HeaderItemContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;

export const HeaderItemText = styled.p`
    padding: 12px;
    height: 15px;
`;

export const HeaderItemIcon = styled.span`
    padding: 12px;
    height: 15px;

    * {
        padding: 0;
        margin: 0;
        fill: ${darkGreen};
    }
`;
